require('./brokerHirePensionPlanStep1.scss');
// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerFormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const BrokerHireAndContributionsModal = require('components/broker/brokerHireAndContributionsModal/brokerHireAndContributionsModal');
// @ commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { AmountInput } = require('commonsComponents/amountInput');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKInput } = require('commonsComponents/OKInput');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { OKLink } = require('commonsComponents/OKLink');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKMessage } = require('commonsComponents/OKMessage');
// @ helpers
const { toCamelCase } = require('utilities/stringHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    BROKER_HIRE_PENSION_PLAN_ANNUAL_INCREMENT_IPC,
    BROKER_HIRE_PENSION_PLAN_ANNUAL_INCREMENT_PERCENTAGE,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_MONTH_VALUE,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_TRIANUAL_VALUE,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_BIANUAL_VALUE,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_ANUAL_VALUE,
    MAX_FRACTION_LENGTH_IN_STORE,
    BROKER_HIRE_PENSION_PLAN_DESIGNATION_DOCUMENT_URL,
    INTERVENER_TYPE_TITULAR,
    BROKER_CONTRIBUTION_PLAN_FRACTION_LENGTH_AMOUNT_VALUE,
    BROKER_CONTRIBUTION_PLAN_MAXIMUN_INTEGER_AMOUNT_LENGTH,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_ANUAL_REV_OPTION_NOREV_VALUE,
    BROKER_CONTRIBUTION_PLAN_FRACTION_LENGTH_PERCENTAGE_VALUE,
    BROKER_CONTRIBUTION_PLAN_MAXIMUN_INTEGER_PERCENTAGE_LENGTH,
    BROKER_HIRE_PENSION_PLAN_PERIODIC_CONTRIBUTION,
    BROKER_HIRE_PENSION_PLAN_CONTRIBUTION
} = require('constants/index');
const language = getLanguage();
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

class BrokerHirePensionPlanStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.handleSetAmount = this.handleSetAmount.bind(this);
        this.handleAnnualIncrementChange = this.handleAnnualIncrementChange.bind(this);
        this.handleRadioButtonSelected = this.handleRadioButtonSelected.bind(this);
        this.handlePeriodicityChange = this.handlePeriodicityChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const isFetchingInterveners = nextProps.isFetchingInterveners;
        const isFetchedIntervenersSuccess = nextProps.isFetchedIntervenersSuccess;
        if (!isFetchingInterveners && isFetchedIntervenersSuccess) {
            nextProps.onIntervenersChange();
        }
    }

    disableNonTitularAccount(immAccount) {
        return immAccount.get('interventionType').trim().toUpperCase() !== INTERVENER_TYPE_TITULAR.trim().toUpperCase()
    }

    buildAccountContainer() {
        const {
            availableAccounts,
            immAccounts,
            selectedAccount,
            onAccountChange,
            immErrorFlags,
            isBlockedAccountsLoading,
            blockedAccountsIds
        } = this.props;
        if (availableAccounts) {
            const dropdownLabel = formatText('brokerHirePlansStep1-ccTitle');
            const accountsAndInterveners = formatText(
                'brokerHirePlansStep1-accountsAndInterveners'
            );
            let detailsLabel;
            const accountValid = immErrorFlags.get('accountValid');
            const immSelectedAccount = immAccounts.get(selectedAccount);
            const accountBalanceValid = immErrorFlags.get('accountBalanceValid');
            const errorMessageKey = accountValid ? 'brokerHirePlansStep1-minimumBalanceError' : 'brokerHirePlansStep1-accountError';
            const errorMessage = formatText(errorMessageKey);
            const errorState = !accountValid || !accountBalanceValid;
            const hirePlanAccountsPlaceholder = formatText('brokerHireInvestmentStep1-hirePlanAccountsPlaceholder')

            if (immSelectedAccount) {
                const contractNumber = immSelectedAccount.get('newContractNumber') || '';
                const productNumber = immSelectedAccount.get('newProduct') || '';
                const owner = immSelectedAccount.get('accountHolder') || '';
                const interventionType = immSelectedAccount.get('interventionType') || '';
                const contract = `${API_ENTERPRISE_NUMBER} ${API_CENTER} ${productNumber}${contractNumber}`;
                const contractLabel = formatText('brokerHireInvestmentStep1-contract');
                const holder = formatText('brokerHireInvestmentStep1-holder');
                const inverventionType = formatText('brokerHireInvestmentStep1-inverventionType');
                detailsLabel = `${contractLabel}${contract} | ${holder}${toCamelCase(owner)} | ${inverventionType}${toCamelCase(interventionType)}`;
            }

            return (
                <div>
                    <h3 className="hire-pension-plan-step1__subtitle">
                        {accountsAndInterveners}
                    </h3>

                    <div className="hire-pension-plan-step1__main-dropdown">
                        <DropdownAccounts
                            id="broker-stocks-contracts"
                            label={dropdownLabel}
                            immAccounts={immAccounts}
                            accountsIndexes={availableAccounts}
                            currentAccountId={selectedAccount}
                            onAccountChange={onAccountChange}
                            error={errorState}
                            errorMsg={errorMessage}
                            showAvailableBalance
                            disableOptionCriteria={this.disableNonTitularAccount}
                            contextPlaceholder={hirePlanAccountsPlaceholder}
                            blockedAccountsIds={blockedAccountsIds}
                            detailsLabel={detailsLabel}
                            loading={isBlockedAccountsLoading}
                        />
                    </div>
                </div>
            );
        } else {
            return <LoadingSection />;
        }
    }

    buildContribution() {
        const {
            immErrorFlags,
            initialContribution,
            minimumPurchase,
            onInitialContributionChange
        } = this.props;

        const initialContributionValid = immErrorFlags.get('initialContributionValid');
        const initialContributionValidBalance = immErrorFlags.get('initialContributionValidBalance');
        const initialContributionBetweenLimits = immErrorFlags.get('initialContributionBetweenLimits');

        const errorState =  !initialContributionValid || !initialContributionValidBalance || !initialContributionBetweenLimits;
        const plainAmountObject = getPlainAmountObject(minimumPurchase);

        let errorMessage;
        if(!initialContributionBetweenLimits) {
            errorMessage = formatText('brokerHirePlansStep1-contributionOverLimitError');
        }
        if (!initialContributionValidBalance) {
            errorMessage = formatText('brokerHirePlansStep1-minimumBalanceError');
        }
        if (!initialContributionValid) {
            errorMessage = formatText('brokerHirePlansStep1-minimumContributionErrorWithoutParameters')
        }

        return (
            <div className="hire-pension-plan-step1__contribution-box">
                <h3 className="hire-pension-plan-step1__subtitle">
                    <FormattedText value="brokerHirePlansStep1-contributionBoxTitle" />
                </h3>
                <div className="hire-pension-plan-step1__disclaimer-container">
                    <OKMessage>
                        <FormattedText value="brokerHirePlansStep1-contributionBoxSubtitle" />
                    </OKMessage>
                </div>
                <div className="hire-pension-plan-step1__contribution-box-input-container">
                    <AmountInput
                        amount={initialContribution}
                        callback={onInitialContributionChange}
                        errorMsg={errorMessage}
                        error={errorState}
                        maxFractionLength={MAX_FRACTION_LENGTH_IN_STORE}
                        maxBackEndFractionLength={BROKER_CONTRIBUTION_PLAN_FRACTION_LENGTH_AMOUNT_VALUE}
                        maxIntegerLength={BROKER_CONTRIBUTION_PLAN_MAXIMUN_INTEGER_AMOUNT_LENGTH}
                        language={language}
                        showBlurZero={__CONTACT_CENTER__}
                        hideFocusZero
                    />
                    <div className="hire-pension-plan-step1__associated-cc-minimal">
                        <FormattedText value="brokerHirePlansStep1-minimal" />
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                        />
                    </div>
                </div>
            </div>
        );
    }

    buildDesignationDocument() {
        const documentLink = (
            <OKLink modifier="emphasize" to={BROKER_HIRE_PENSION_PLAN_DESIGNATION_DOCUMENT_URL} target="_blank">
                <FormattedText value="brokerHirePlansStep1-designationDocumentLink" />
            </OKLink>
        );

        return (
            <BrokerFormattedTextWithComponents
                value="brokerHirePlansStep1-designationDocument"
                injectedComponents={[documentLink]}
            />
        );
    }

    buildDisclaimerInfo() {
        const link = formatText('disclaimerPersonalInfo-planesGdprDisclaimerLinkUrl');

        return (
            <div className="hire-pension-plan-step1__disclaimer-personal-info">
                <OKMessage type="informative">
                    <FormattedText value="disclaimerPersonalInfo-planesGdprDisclaimerText" />
                    &nbsp;
                    <OKLink to={link} target="_blank" modifier="emphasize">
                        <FormattedText value="disclaimerPersonalInfo-planesGdprDisclaimerLinkText" />
                    </OKLink>
                </OKMessage>
            </div>
        );
    }

    buildIntervenerContainer() {
        const intervenersLabel = formatText('brokerHirePlansStep1-participant');
        return (
            <div className="hire-pension-plan-step1__main-dropdown">
                <h3 className="hire-pension-plan-step1__subtitle">
                    <FormattedText value="brokerHirePlansStep1-intervenerTitle" />
                </h3>
                <OKInput
                    label={intervenersLabel}
                    value={this.props.selectedIntervenerLabel}
                    disabled={true}
                />
            </div>
        );
    }

    createAnualRev() {
        const { annualIncrement, immErrorFlags } = this.props;
        const ANNUAL_INCREMENT_OPTIONS = [
            {
                label: formatText('brokerHirePlansStep1-annualIncrementPercentage'),
                value: BROKER_HIRE_PENSION_PLAN_ANNUAL_INCREMENT_PERCENTAGE
            },
            {
                label: formatText('brokerHirePlansStep1-annualIncrementIPC'),
                value: BROKER_HIRE_PENSION_PLAN_ANNUAL_INCREMENT_IPC
            },
            {
                label: formatText('brokerHirePlansStep1-withoutAnnualIncrement'),
                value: BROKER_CONTRIBUTION_PLAN_PERIODIC_ANUAL_REV_OPTION_NOREV_VALUE
            }
        ];
        const anualIncrementLabel = formatText('brokerHirePlansStep1-contributionBoxPeriodicContributionIncrementSubtitle');
        return (
            <span className="broker-pension-plan-periodic-contribution-step1__rev-anual">
                <OKSelect
                    label={anualIncrementLabel}
                    onChange={this.handleAnnualIncrementChange}
                    options={ANNUAL_INCREMENT_OPTIONS}
                    value={annualIncrement}
                    autosize={false}
                    searchable={false}
                    placeholder={formatText('pensionPlanContribution-step1MonthlyPlaceHolder')}
                    errorState={!immErrorFlags.get('revAnualNotError')}
                    errorMessage={formatText('pensionPlanContribution-revAnnualError')}
                />
            </span>
        );
    }

    createDatePicker() {
        const { onDateChange, periodicContributionDate, minDate } = this.props;
        const dateLabel = formatText('brokerHirePlansStep1-contributionBoxPeriodicContributionValidity');
        return (
            <span className="broker-pension-plan-periodic-contribution-step1__date-picker">
                <DatePickerCustom
                    callback={onDateChange}
                    selectedDate={periodicContributionDate}
                    label={dateLabel}
                    placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                    locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                    dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                    minDate={minDate}
                />
                <FormattedText
                    className="broker-pension-plan-periodic-contribution-step1__disable-hour"
                    value="pensionPlanContribution-disableHour" // disableHour
                />
                <FormattedText
                    className="broker-pension-plan-periodic-contribution-step1__peninsular-schedule"
                    value="pensionPlanContribution-peninsularSchedule" // peninsularSchedule
                />
            </span>
        );
    }

    createMonthlyDropdown() {
        const { periodicContributionPeriodicity } = this.props;
        const PERIODICITY_OPTIONS = [
            {
                label: formatText('brokerHirePlansStep1-monthlyPeriodicity'),
                frecuenciaCuotaCada: 1,
                frecuenciaCuotaCadaUnidadDeTiempo: 2,
                value: BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_MONTH_VALUE
            },
            {
                label: formatText('brokerHirePlansStep1-quaterlyPeriodicity'),
                frecuenciaCuotaCada: 3,
                frecuenciaCuotaCadaUnidadDeTiempo: 2,
                value: BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_TRIANUAL_VALUE
            },
            {
                label: formatText('pensionPlanPeriodicalContribution-semestralOptionLabel'),
                frecuenciaCuotaCada: 6,
                frecuenciaCuotaCadaUnidadDeTiempo: 2,
                value: BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_BIANUAL_VALUE
            },
            {
                label: formatText('brokerHirePlansStep1-annualPeriodicity'),
                frecuenciaCuotaCada: 1,
                frecuenciaCuotaCadaUnidadDeTiempo: 3,
                value: BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_ANUAL_VALUE
            }
        ];
        const periodicityLabel = formatText('brokerHirePlansStep1-contributionBoxPeriodicContributionPeriodicity');
        return (
            <div className={`broker-pension-plan-periodic-contribution-step1__select`}>
                <OKSelect
                    label={periodicityLabel}
                    onChange={this.handlePeriodicityChange}
                    options={PERIODICITY_OPTIONS}
                    value={periodicContributionPeriodicity}
                    autosize={false}
                    placeholder={''}
                    searchable={false}
                />
            </div>
        );
    }

    createPercentage() {
        const { annualIncrementPercentage, onAnnualIncrementPercentageChange, immErrorFlags, isPercentageInputAvailable } = this.props;
        const percentageLabel = formatText('brokerHirePlansStep1-annualIncrementPercentage');
        let persentageInput;

        if (isPercentageInputAvailable) {

            const isAnnualIncrementPercentageNotError = immErrorFlags.get('annualIncrementPercentageNotError');
            const isAnnualIncrementPercentageNotEmpty = immErrorFlags.get('annualIncrementPercentageNotEmpty');

            let errorMessage
            if (!isAnnualIncrementPercentageNotError) {
                errorMessage = formatText('pensionPlanContribution-percentageOutOfLimits');
            }
            if (!isAnnualIncrementPercentageNotEmpty) {
                errorMessage = formatText('pensionPlanContribution-errorEmptyPercentage');
            }

            persentageInput = (
                <span className="broker-pension-plan-periodic-contribution-step1__amount">
                    <AmountInput
                        maxFractionLength={BROKER_CONTRIBUTION_PLAN_FRACTION_LENGTH_PERCENTAGE_VALUE}
                        maxBackEndFractionLength={BROKER_CONTRIBUTION_PLAN_FRACTION_LENGTH_PERCENTAGE_VALUE}
                        maxIntegerLength={BROKER_CONTRIBUTION_PLAN_MAXIMUN_INTEGER_PERCENTAGE_LENGTH}
                        error={!isAnnualIncrementPercentageNotError || !isAnnualIncrementPercentageNotEmpty}
                        errorMsg={errorMessage}
                        amount={annualIncrementPercentage}
                        callback={onAnnualIncrementPercentageChange}
                        label={percentageLabel}
                        language={language}
                        hideFocusZero
                    />
                </span>
            );
        }
        return persentageInput;
    }

    createMinimalAmountLabel(minimalPeriodicity) {
        const { periodicContributionPeriodicity } = this.props;
        const plainAmountObject = getPlainAmountObject(minimalPeriodicity);
        return (
            <div className="broker-pension-plan-periodic-contribution-step1__associated-cc-minimal">
                <FormattedText
                    value="pensionPlanContribution-minimalWithParameter"
                    injectedStrings={[periodicContributionPeriodicity]}
                />
                <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
            </div>
        );
    }

    createPeriodiclyAmount() {
        const { periodicContributionAmount, onPeriodicityAmountChange, immErrorFlags, minimumAdditionalPurchase, contributionMinimumAmountCurrency } = this.props;
        const periodicityAmountNotError = immErrorFlags.get('periodicityAmountNotError');
        const minimalPeriodicity = {
            amount: minimumAdditionalPurchase,
            currency: contributionMinimumAmountCurrency
        };
        const minimalText = this.createMinimalAmountLabel(minimalPeriodicity);
        const amountLabel = formatText('brokerHirePlansStep1-contributionBoxPeriodicContributionContribution');

        let errorMessage
        if (!periodicityAmountNotError) {
            errorMessage = formatText('brokerHirePlansStep1-minimumContributionErrorWithoutParameters')
        }

        return (
            <span className="broker-pension-plan-periodic-contribution-step1__amount">
                <AmountInput
                    amount={periodicContributionAmount}
                    callback={onPeriodicityAmountChange}
                    error={!periodicityAmountNotError}
                    errorMsg={errorMessage}
                    label={amountLabel}
                    language={language}
                    maxFractionLength={MAX_FRACTION_LENGTH_IN_STORE}
                    maxBackEndFractionLength={BROKER_CONTRIBUTION_PLAN_FRACTION_LENGTH_AMOUNT_VALUE}
                    maxIntegerLength={BROKER_CONTRIBUTION_PLAN_MAXIMUN_INTEGER_AMOUNT_LENGTH}
                    hideFocusZero
                />
                {minimalText}
            </span>
        );
    }

    buildPeriodicContribution() {
        return (
            <div>
                <h2 className="broker-pension-plan-periodic-contribution-step1__informative-text">{formatText('pensionPlanContribution-informativeText')}</h2>
                <div className="broker-pension-plan-contribution__group-div broker-pension-plan-periodic-contribution-step1__periodicly-box">
                    <div>
                        {this.createDatePicker()}
                        {this.createMonthlyDropdown()}
                        {this.createPeriodiclyAmount()}
                    </div>
                    <h2 className="broker-pension-plan-contribution__subtitle">{formatText('pensionPlanContribution-step1PeriodiclySection')}</h2>
                    <div>{this.createAnualRev()}{this.createPercentage()}</div>
                </div>
            </div>
        );
    }

    handleAnnualIncrementChange(evt) {
        this.props.onAnnualIncrementChange(evt.value);
    }

    handlePeriodicityChange(evt) {
        this.props.onPeriodicityChange(evt);
    }

    handleSetAmount(evt) {
        this.props.onInitialContributionChange(evt.target.value);
    }

    handleRadioButtonSelected(answer) {
        this.props.setContributionAnswer(answer);
    }

    buildRadioButtonGroup() {
        const  { contributionQuestion } = this.props;
        const answer = contributionQuestion.get('answer');
        const options = contributionQuestion.get('options').map((option) => {
            let legend;
            if (answer === option.get('id') && option.get('id') === BROKER_HIRE_PENSION_PLAN_CONTRIBUTION) {
                legend = formatText('brokerHirePlansStep1-noPeriodicContributionLegend');
            }
            const label= (
                <div>
                    <p>{formatText(option.get('description'))}</p>
                    <p className="hire-pension-plan-step1__contribution-question-legend">{legend}</p>
                </div>
            )
            return (
                <RadioButton
                    key={option.get('id')}
                    label={label}
                    value={option.get('id')}
                />
            );
        });

        return (
            <div className={'hire-pension-plan-step1'}>
                <h5 className={'hire-pension-plan-step1'}>
                    {formatText(contributionQuestion.get('question'))}
                </h5>
                <RadioButtonGroup
                    name="contributionRadioGroup"
                    idPrefix="contributionRadioGroupPrefix"
                    onChange={this.handleRadioButtonSelected}
                    selectedValue={answer}
                >
                    {options}
                </RadioButtonGroup>
            </div>
        );
    }

    render() {
        const  {contributionQuestion, pensionPlanProvider } = this.props;
        const accountsContainer = this.buildAccountContainer();
        const intervenerContainer = this.buildIntervenerContainer();
        const contributionContainer = this.buildContribution();
        const designationDocument = this.buildDesignationDocument();
        const disclaimerInfo = this.buildDisclaimerInfo();
        const radioButtonGroup = this.buildRadioButtonGroup();

        let periodicContributionContainer;
         if (contributionQuestion.get('answer') === BROKER_HIRE_PENSION_PLAN_PERIODIC_CONTRIBUTION) {
             periodicContributionContainer = this.buildPeriodicContribution();
         }

        return (
            <div>
                <h2 className="hire-pension-plan-step1__title">
                    <FormattedText value="brokerHirePlansStep1-title" />
                </h2>
                <BrokerHireAndContributionsModal pensionPlanProvider={pensionPlanProvider}/>
                {accountsContainer}
                {intervenerContainer}
                {contributionContainer}
                {radioButtonGroup}
                {periodicContributionContainer}
                {designationDocument}
                {disclaimerInfo}
            </div>
        );
    }
}

BrokerHirePensionPlanStep1.propTypes = {
    annualIncrement: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    annualIncrementPercentage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    availableAccounts: PropTypes.array.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immErrorFlags: PropTypes.object.isRequired,
    immInterveners: PropTypes.object.isRequired,
    initialContribution: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    isBlockedAccountsLoading: PropTypes.bool.isRequired,
    minimumAdditionalPurchase: PropTypes.object.isRequired,
    minimumPurchase: PropTypes.object.isRequired,
    onAccountChange: PropTypes.func.isRequired,
    onAnnualIncrementChange: PropTypes.func.isRequired,
    onAnnualIncrementPercentageChange: PropTypes.func.isRequired,
    onDateChange: PropTypes.func.isRequired,
    onInitialContributionChange: PropTypes.func.isRequired,
    onPeriodicityAmountChange: PropTypes.func.isRequired,
    onPeriodicityChange: PropTypes.func.isRequired,
    periodicContributionAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    periodicContributionDate: PropTypes.object.isRequired,
    periodicContributionPeriodicity: PropTypes.string.isRequired,
    pensionPlanProvider: PropTypes.string.isRequired,
    selectedAccount: PropTypes.string.isRequired,
    immProfile: PropTypes.object,
    contributionQuestion: PropTypes.object,
    setContributionAnswer: PropTypes.func.isRequired,
    isPercentageInputAvailable: PropTypes.func.isRequired,
    contributionMinimumAmountCurrency: PropTypes.string.isRequired,
    selectedIntervenerLabel: PropTypes.string.isRequired,
    onIntervenersChange: PropTypes.func.isRequired,
    isFetchingInterveners: PropTypes.bool.isRequired,
    isFetchedIntervenersSuccess: PropTypes.bool.isRequired,
    minDate: PropTypes.object.isRequired,
    blockedAccountsIds: PropTypes.array
};

module.exports = BrokerHirePensionPlanStep1;
